import { render, staticRenderFns } from "./staff-selector.vue?vue&type=template&id=144b6594&scoped=true"
import script from "./staff-selector.vue?vue&type=script&lang=ts"
export * from "./staff-selector.vue?vue&type=script&lang=ts"
import style0 from "./staff-selector.vue?vue&type=style&index=0&id=144b6594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b6594",
  null
  
)

export default component.exports